import { Component, ElementRef, EventEmitter, Inject, Input, Output, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { EntryService } from '../../entry.service';
import { PlatformService } from 'src/app/platform.service';
import { GoogleAnalyticsService } from 'src/app/google-analytics.service';
import { UtilService } from 'src/app/util.service';
import { MolstarPluginService } from 'src/app/molstar-plugin-service';
import { EntrySelectors } from 'src/app/state/entry.selectors';
import { EntryData } from '../../structure-data.models';
import { filter, tap } from 'rxjs';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ModelConfidenceComponent } from '../model-confidence/model-confidence.component';
import { ViewState } from '../domains/domains.component';
@Component({
  selector: 'app-similar-proteins',
  templateUrl: './similar-proteins.component.html',
  styleUrl: './similar-proteins.component.css',
  standalone: false
})
export class SimilarProteinsComponent {
  @Output() handleSelectedStructureinParent = new EventEmitter<{ accession: string, apidata: any, color: string, checked:boolean }>();

  public afdb_accession: string;
  public expanded = signal<boolean>(false);
  public listHomeMenu = [];
  constructor(
    private store: Store,
    private entryService: EntryService,
    private utilService: UtilService,
    public gaService: GoogleAnalyticsService,
    private platform: PlatformService,
    private el: ElementRef,
    private molstarPluginService: MolstarPluginService,
    public bottomSheetRef: MatBottomSheetRef<ModelConfidenceComponent>
  ) {}
  public uniprotAccession = toSignal(this.store.select(EntrySelectors.uniprotAccession));
  public accession = toSignal(this.store.select(EntrySelectors.accession));
  public entryData = signal<EntryData>({} as EntryData);
  public currentViewState = signal<ViewState>(ViewState.List);
  public viewStates = ViewState;
  public activeMenu =  signal<any>(null);
  public title = this.entryService.domainTitle;
  ngOnInit(): void {
    this.entryService.updateSelectedDomainTitle('Similar Proteins');
    this.store
    .select(EntrySelectors.entryData)
    .pipe(
      filter(Boolean),
      tap((data) => {
        return this.entryData.set(data);
      })
    )
    .subscribe(() => {
      this.afdb_accession = this.entryData().modelEntityId;
      // this.uniprotAccession = this.entryData().uniprotAccession;
    });
   this.listHomeMenu = [
    {
      id: 1,
      title: "Structure similarity cluster",
      subtitle: "Homologous proteins"
    },
    {
      id: 2,
      title: "Similar structures",
      subtitle: "PDB and AFDB50"
    }
   ]
  }

  public closeBottomSheet(): void {
    this.bottomSheetRef.dismiss();
    this.entryService.updateSelectedComponent(null);
    this.entryService.updateSelectedTabName('');
  }

  public toggleBottomsheetHeight(): void {
    this.expanded.update((olamide) => !olamide);
    const container = document.querySelector(
      '.custom-bottom-sheet'
    ) as HTMLElement;
    if (container) {
      container.style.height = this.expanded() ? '50%' : '10%';
    }
    //for GA tag
    let tag = "bottomsheet_toggle_up";
    let gtagmsg = "Opening bottomsheet up";
    if(!this.expanded()){
      tag = "bottomsheet_toggle_down";
      gtagmsg = "Collapsing bottomsheet down";
    }
    this.gaService.eventEmitter('bottomsheet_toggle', 'mobile_overlay_interaction', 'tap', tag, gtagmsg);
  }
  handleSelectedStructure({accession, apidata, color, checked}){
    this.handleSelectedStructureinParent.emit({ accession, apidata, color, checked });
  }

  public navigateToDetail(menu) {

    this.currentViewState.set(ViewState.Detail);
    this.activeMenu.set(menu);
    this.entryService.updateSelectedDomainTitle(menu.title);
  }
  public async goBackToList() {
    this.currentViewState.set(ViewState.List);
    this.entryService.updateSelectedDomainTitle('Similar Proteins');
    // await this.molstarVisualisation.resetMobileMolstarInitial();
  }
}
